import React, { useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useIsAuthenticated } from "@azure/msal-react";
import { useDispatch, useSelector } from 'react-redux';
import { fetchPermissions } from '../../redux/permissionsSlice';
import usePhoneMode from '../../hooks/usePhoneMode';
import { useTheme } from '@mui/material/styles';
import NavCenterSection from './Center/NavCenterSection';
import useReportDevice from './hooks/useReportDevice';
import NavRightSection from './Right/NavRightSection';
import useLiteratureCurrentView from './hooks/useLiteratureCurrentView';
import AppMenu from './Left/AppMenu';

export default function LiteratureNavMenu() {
    useReportDevice();
    const { menuTitle, isInFaultView } = useLiteratureCurrentView();
    const theme = useTheme();
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const { isMobile } = usePhoneMode();
    const isLoaded = useSelector((state) => state.permissions.isLoaded)

    useEffect(() => {
        if (isAuthenticated && !isLoaded) {
            dispatch(fetchPermissions());
        }
    }, [isAuthenticated, isLoaded]);
    return (
        <>
            <Box sx={{ flexGrow: 1, height: `${theme.appBar.height}px` }} className='navMenu'>
                <AppBar position="fixed" style={{ height: theme.appBar.height }}>
                    <Toolbar>
                        <AppMenu />
                        {!isMobile ? (
                            <>
                                <img title='Mercury Marine' className='logo' src='wavelogo.png' style={{ maxHeight: '1.25em', marginRight: '0.5em' }} />
                                <Typography variant="h6" component="div" noWrap>
                                    {menuTitle}
                                </Typography>
                            </>
                        ) : null}
                        {isMobile && isInFaultView ? (
                            <Typography variant="h6" component="div" noWrap>
                                {menuTitle}
                            </Typography>
                        ) : null}
                        <Box sx={{ flexGrow: 1 }} />

                        {/* Center Section */}
                        <NavCenterSection />

                        {/* Right Section */}
                        <NavRightSection />
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    );
}